export default __webpack_public_path__ + "static/media/coast.970fc724.jpeg";